import React from "react";

const AVATARS = [
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=60&q=80",
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=60&q=80",
  "https://images.unsplash.com/photo-1614786269829-d24616faf56d?w=60&q=80",
];

export const AuthHeroPanel = () => (
  <div className="hidden lg:flex lg:w-1/2 bg-[#0F172A] relative overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80"
        alt="Professional meeting"
        className="w-full h-full object-cover opacity-30"
      />
    </div>
    <div className="relative z-10 flex flex-col justify-end p-16 text-white">
      <div className="mb-8">
        <div className="w-8 h-8 bg-white rounded-sm flex items-center justify-center mb-6">
          <span className="text-[#0F172A] text-sm font-bold font-serif">C</span>
        </div>
        <h1 className="text-4xl font-normal leading-tight mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Where expertise meets<br /><em>opportunity.</em>
        </h1>
        <p className="text-white/70 text-base leading-relaxed max-w-sm">
          Connect with accomplished professionals who&apos;ve shaped industries, built companies, and led transformations.
        </p>
      </div>
      <div className="flex items-center gap-4 border-t border-white/20 pt-8">
        <div className="flex -space-x-2">
          {AVATARS.map((src) => (
            <img key={src} src={src} alt="" className="w-9 h-9 rounded-full border-2 border-[#0F172A] object-cover" />
          ))}
        </div>
        <div>
          <p className="text-white font-semibold text-sm">500+ experts</p>
          <p className="text-white/60 text-xs">across 15+ industries</p>
        </div>
      </div>
    </div>
  </div>
);
